import { useCallback, useEffect, useState } from 'react';

export interface WindowSize {
  width: number;
  height: number;
  ratio: number;
}

function getWindowSize(): WindowSize {
  const width = window.innerWidth;
  const height = window.innerHeight;
  return {
    width,
    height,
    ratio: height > 0 ? width / height : 0,
  };
}

export default function useResize(): WindowSize {
  const [size, setSize] = useState<WindowSize>(getWindowSize);

  const handleResize = useCallback(() => {
    setSize(getWindowSize());
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);

  return size;
}
